import { cx } from '@/utils';
import { useDotButton } from '@common/DotButton/DotButton';
import { TitleWrapper } from '@views/Home/components';
import useEmblaCarousel from 'embla-carousel-react';

import { BlockColor } from '@/components/blocks/PageQuickAccessBar/admin/components/GeneralInformationQuickAccessBar';
import { splitTitle } from '@/components/views/Home/components/TitleWrapper';

import CarouselDots from '../../../common/CarouselDots';
import { QuickAccessCard, QuickAccessGrid } from './components';
import { CarouselNavigation } from './components/CarouselNavigation';
import styles from './styles.module.css';
import { getWrapperBackgroundColor, QuickAccessSharedProps } from './utils';

const DesktopStyleA = ({
  quickAccessBar,
  isCarousel,
  isLightBackground,
  itemsPerView,
  sortedItems,
}: QuickAccessSharedProps) => {
  const [emblaRefA, emblaApiA] = useEmblaCarousel({
    slidesToScroll: itemsPerView,
    containScroll: 'trimSnaps',
    breakpoints: {
      '(max-width: 767px)': {
        slidesToScroll: 1,
      },
    },
  });

  const {
    selectedIndex: selectedIndexA,
    scrollSnaps: scrollSnapsA,
    onDotButtonClick: onDotButtonClickA,
  } = useDotButton(emblaApiA);

  const [title1, title2] = splitTitle(quickAccessBar?.blockTitle, {
    show: quickAccessBar?.showTitle,
    defaultTitle1: 'Accesos',
    defaultTitle2: 'rápidos',
  });

  return (
    <section
      className={cx('pb-[20px] pt-[40px]', getWrapperBackgroundColor(quickAccessBar?.color))}
    >
      <div className={cx('inner-extend text-white', styles.titleWrapper)}>
        <TitleWrapper
          isDefault
          title1={title1}
          title2={title2}
          description={quickAccessBar?.showDescription ? quickAccessBar?.publicDescription : ''}
          action={
            quickAccessBar?.seeMoreTitle
              ? {
                  text: quickAccessBar.seeMoreTitle,
                  onClick: () => {
                    if (quickAccessBar?.seeMoreLink) {
                      window.open(quickAccessBar.seeMoreLink);
                    }
                  },
                }
              : undefined
          }
          classname={styles.titleName}
          title1ClassName={
            quickAccessBar?.color === BlockColor.WHITE || quickAccessBar?.color === BlockColor.GRAY
              ? 'text-primary text-xl font-semibold md:text-[32px]'
              : 'text-white text-xl font-semibold md:text-[32px]'
          }
          title2ClassName={
            quickAccessBar?.color === BlockColor.WHITE || quickAccessBar?.color === BlockColor.GRAY
              ? 'pl-2 font-montserrat text-xl md:text-[32px] text-tundora'
              : 'pl-2 font-montserrat text-xl md:text-[32px] text-white'
          }
          descriptionClassName={
            isLightBackground
              ? 'font-workSans text-base font-normal not-italic 3xl:text-lg text-tundora'
              : 'font-workSans text-base font-normal not-italic 3xl:text-lg text-white'
          }
          borderClassName={isLightBackground ? 'border-primary' : 'border-white'}
        />
      </div>
      <div className={' relative mt-[10px] overflow-hidden'}>
        {/* Botones de navegación solo si es carrusel */}
        {isCarousel && (
          <div className="hidden md:block">
            <CarouselNavigation
              onPrev={() => emblaApiA?.scrollPrev()}
              onNext={() => emblaApiA?.scrollNext()}
            />
          </div>
        )}

        {/* Contenedor principal */}
        <div className="inner-extend">
          {isCarousel ? (
            // Modo Carrusel
            <div className="overflow-hidden px-1 py-3" ref={emblaRefA}>
              <div className="flex gap-[26px]">
                {sortedItems?.map((link, key) => (
                  <div
                    key={key}
                    className="flex-none"
                    style={{
                      width: `calc((100% - ${(itemsPerView - 1) * 26}px) / ${itemsPerView})`,
                      minWidth: '279px',
                    }}
                  >
                    <QuickAccessCard item={link as any} className="w-full" variant="vertical" />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            // Modo Grid
            <QuickAccessGrid items={sortedItems as any} variant="vertical" />
          )}
        </div>
      </div>

      {/* Dots solo si es carrusel */}
      {isCarousel && (
        <CarouselDots
          scrollSnaps={scrollSnapsA}
          selectedIndex={selectedIndexA}
          onDotClick={onDotButtonClickA}
          dotClassName={cx('dot !h-3 !w-3', isLightBackground ? styles.dotLight : undefined)}
          selectedClassName={isLightBackground ? styles.dotLightSelected : styles.dotDarkSelected}
        />
      )}
    </section>
  );
};

export default DesktopStyleA;
